import Types from "./types";
import { VehicleService } from "../../../service/vehicle-service";
import getTestimonialsWithRating from "../../../utils/helpers/get-testimonials-with-rating";
import { EChallanCmsService } from "../../../service/e-challan-cms-service";
import { parseCmsChallanData } from "../../../utils/helpers/parse-cms-e-challan-data";
// import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import { CHALLAN_PAGE_TYPE, ORDER_FILTER_PAYLOAD } from "../../../constants/challan-constants";
import { SuperAppCmsService } from "../../../service/super-app-cms-service";

const setDetails = data => ({
    type: Types.SET_DETAILS,
    data
});

const setRegNumberList = data => ({
    type: Types.SET_DETAILS,
    data
});

const setRecentTransaction = data => ({
    type: Types.SET_DETAILS,
    data
});

const fetchChallanLandingPageData = () => dispatch => {
    return new Promise((resolve, reject) => {
        EChallanCmsService.getChallanCmsData()
            .then(response => {
                const parsedChallanData = parseCmsChallanData(response.data.data);
                dispatch(setDetails({
                    cmsContent: parsedChallanData || {},
                    pageType: CHALLAN_PAGE_TYPE.TRAFFIC_CHALLAN
                }));
                resolve(parsedChallanData);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchTestimonials = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchTestimonialsByCategory(payload)
            .then(response => {
                dispatch(setDetails({
                    testimonials: getTestimonialsWithRating(response.data.detail || [])
                }));
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchRegNumberList = (authToken) => dispatch => {
    // return new Promise((resolve, reject) => {
    //     LeadServiceJava.fetchLeadFilterData(token, REG_NUMBERS_FILTER_PAYLOAD)
    //         .then(response => {
    //             dispatch(setRegNumberList({
    //                 regNumberList: (response.data.content || [])
    //             }));
    //             resolve(response.data.content);
    //         })
    //         .catch(error => {
    //             reject(error);
    //         });
    // });
    return new Promise((resolve, reject) => {
        SuperAppCmsService.getVehicleRegistry({authToken})
            .then(response => {
                dispatch(setRegNumberList({
                    regNumberList: (response || [])
                }));
                resolve(response || []);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchOrderData = (token) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getOrderByIdentifier(token, ORDER_FILTER_PAYLOAD)
            .then(response => {
                dispatch(setRecentTransaction({
                    recentTransaction: (response.data.content?.[0] || null)
                }));
                resolve(response.data.content);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    fetchTestimonials,
    fetchChallanLandingPageData,
    fetchRegNumberList,
    fetchOrderData
};
